export default ({ h, s, v }) => {
  let l = v * (1 - s / 2),
    sl = l === 0 || l === 1 ? 0 : (v - l) / Math.min(l, 1 - l);
  return { h, s: sl, l };
};
